import React, { useState, useEffect } from "react";
import { exampleService } from "../../services/example.service";
import "./PodcastPage.css";
import AddFile from "../../components/DisplayFiles/AddFile";
import IsAdmin from "../../components/IsAdmin/IsAdmin";
import DisplayFiles from "../../components/DisplayFiles/DisplayFiles";
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { useTranslation } from "react-i18next";
import enTranslations from "../../en.json";
import arTranslations from "../../ar.json";

i18n.use(initReactI18next).init({
  resources: {
    en: { translation: enTranslations },
    ar: { translation: arTranslations },
  },
  lng: "en",
  fallbackLng: "en",
  interpolation: { escapeValue: false },
});
export default function PodcastPage() {
  const [files, setFiles] = useState([]);
  const { t } = useTranslation();
  async function handleGetAllPodcasts() {
    const response = await exampleService.getAllPodcasts();

    setFiles(response.data);
  }
  useEffect(() => {
    handleGetAllPodcasts();
  }, []);
  return (
    <div className="Podcast-Page">
      <h1 className="title">{t("podcasts")}</h1>
      <IsAdmin>
        <AddFile handleGetAllPodcasts={handleGetAllPodcasts} />
      </IsAdmin>
       <DisplayFiles files={files} handleGetAllPodcasts={handleGetAllPodcasts} />
    </div>
  );
}
